export function callPhone(phone) {
    // eslint-disable-next-line no-undef
    ZWJSBridge.phoneCall({"corpId": phone,})
        .catch(() => {
            window.open('tel:'+phone)
        })
}
